import { observer } from "mobx-react";
import _ from "lodash";
import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useStores } from "../../stores/root-store";
import DriverListing from "./drivers-listing";
import DriverForm from "./driver-form";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ManageDrivers = observer(() => {
  const { deliveryStore } = useStores();
  const { editDriver, setEditDriver } = deliveryStore;
  const [showDriverForm, setShowDriverForm] = useState(false);

  const handleDriverFormClose = (show: boolean) => {
    setShowDriverForm(show);
    if (!show) setEditDriver(null);
  };

  useEffect(() => {
    if (editDriver) setShowDriverForm(editDriver.deliveryDriverId > 0);
  }, [editDriver]);

  return (
    <div className="container mt-3 pb-3">
      <div className="row mb-3">
        <h5 className="mb-0 text-start">
          Delivery Drivers
          <Button
            onClick={() => setShowDriverForm(true)}
            className="btn-default float-end"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            New Driver
          </Button>
        </h5>
      </div>
      <DriverListing />
      {showDriverForm && (
        <DriverForm
          show={showDriverForm}
          setShowModal={handleDriverFormClose}
        />
      )}
    </div>
  );
});

export default ManageDrivers;
